export const AuraMark = ({ className = "w-9 h-9" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="am-tile" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#232323" /><stop offset="1" stopColor="#0E0E0E" />
      </linearGradient>
      <linearGradient id="am-gold" x1="12" y1="8" x2="36" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F0D49B" /><stop offset="0.5" stopColor="#C8A15C" /><stop offset="1" stopColor="#8A6A28" />
      </linearGradient>
      <linearGradient id="am-gold2" x1="24" y1="10" x2="24" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#E6C88A" /><stop offset="1" stopColor="#A9822F" />
      </linearGradient>
    </defs>
    <rect x="1" y="1" width="46" height="46" rx="11" fill="url(#am-tile)" stroke="#3a3226" strokeWidth="0.75" />
    <path d="M24 11 L37 39 H30.5 L24 24 Z" fill="url(#am-gold)" />
    <path d="M24 11 L11 39 H17.5 L24 24 Z" fill="url(#am-gold2)" opacity="0.92" />
    <path d="M24 24 L27.5 32 H20.5 Z" fill="#0E0E0E" opacity="0.55" />
  </svg>
);

export const AuraWordmark = ({ className = "" }) => (
  <span className={`font-serif-italic not-italic font-medium tracking-tight text-slate-100 ${className}`} style={{ fontStyle: "normal" }}>
    AuraSession
  </span>
);
